import { render, staticRenderFns } from "./CbxPaymentMethod.vue?vue&type=template&id=4a1edeb4&"
import script from "./CbxPaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./CbxPaymentMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports